// extracted by mini-css-extract-plugin
export default {"header":"ChatHeader-module_header_YFMlG","closeIcon":"ChatHeader-module_closeIcon_WmvAZ"};